/**
 * @param {function} fn 
 * @param {int} delay miliseconds
 * @returns {function}
 */
const debounce = (fn, delay) => {
    var timeoutId = null;
    return function () {
        clearTimeout(timeoutId);
        var args = arguments;
        var that = this;
        timeoutId = setTimeout(function () {
            fn.apply(that, args);
        }, delay);
    };
};

export { debounce }
   